import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import {
    restriction,
    getUserRestriction,
    getDocumentRestriction,
    getEventRestriction,
    getSupplierRestriction,
    getContractorRestriction,
    updateUserRestriction,
    updateDocumentRestriction,
    updateEventRestriction,
    updateSupplierRestriction,
    updateContractorRestriction,
    getDocumentRestrictionsingle,
} from '../../constant/restriction';
import axios from "axios";
import { URL } from '../../Apis/Constants';
import { ASSETS_SERVICE, CONTRACTOR_SERVICE, DOCUMENT_SERVICE, SUPPLIER_SERVICE, USER_SERVICE } from '../EndPoints';

const SETTING_ID = 1;

// gets api
export const GetUserRestriction = createAsyncThunk(
    `${restriction}/${getUserRestriction}`,
    async (params, { dispatch, getState }) => {
        const result = await axios
            .get(URL+USER_SERVICE.getUserRestriction)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
           const { data, status } = result;
        return { data, status };
    },
);

export const GetDocumentRestriction = createAsyncThunk(
    `${restriction}/${getDocumentRestriction}`,
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(ASSETS_SERVICE.getDocumentRestriction)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
// get
export const GetDocumentRestrictionsingle = createAsyncThunk(
    `${restriction}/${getDocumentRestrictionsingle}`,
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(DOCUMENT_SERVICE.getDocumentRestrictionsingle)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// update api
export const UpdateUserRestriction = createAsyncThunk(
    `${restriction}/${updateUserRestriction}`,
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put(USER_SERVICE.updateUserRestriction, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const UpdateDocumentRestriction = createAsyncThunk(
    `${restriction}/${updateDocumentRestriction}`,
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put(DOCUMENT_SERVICE.updateDocumentRestriction, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const UpdateEventRestriction = createAsyncThunk(
    `${restriction}/${updateEventRestriction}`,
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put('event-service/restriction/update', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// ====== supplier-setting
export const GetSupplierRestriction = createAsyncThunk(
    `${restriction}/${getSupplierRestriction}`,
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(SUPPLIER_SERVICE.getSupplierRestriction)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const UpdateSupplierRestriction = createAsyncThunk(
    `${restriction}/${updateSupplierRestriction}`,
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put(SUPPLIER_SERVICE.updateSupplierRestriction, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
// ====== end supplier-setting


// ====== contractor-setting
export const GetContractorRestriction = createAsyncThunk(
    `${restriction}/${getContractorRestriction}`,
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`${CONTRACTOR_SERVICE.getContractorRestriction}${SETTING_ID}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const UpdateContractorRestriction = createAsyncThunk(
    `${restriction}/${updateContractorRestriction}`,
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put(CONTRACTOR_SERVICE.updateContractorRestriction, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
// ====== end contractor-setting
